import apiSlice from 'app/apiSlice';

const dashboardApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getStats: builder.query({
      query: params => ({
        url: `campaigns/stats${params}`,
      }),
      transformResponse: response => {
        return response.data;
      },
    }),

    getStatsById: builder.query({
      query: ({ id, params }) => ({
        url: `campaigns/${id}/stats${params}`,
      }),
      transformResponse: response => {
        return response.data;
      },
    }),

    getPrintStates: builder.query({
      query: params => ({
        url: `campaigns/stats/prints${params}`,
      }),
    }),

    getPrintedOrderStates: builder.query({
      query: params => ({
        url: `campaigns/stats/printed-orders${params}`,
      }),
    }),

    getQrCodesStats: builder.query({
      query: params => ({
        url: `links/stats${params}`,
      }),
    }),
  }),
  overrideExisting: false, // Avoid overwriting existing endpoints
});

export const {
  useGetStatsQuery,
  useGetStatsByIdQuery,
  useGetPrintStatesQuery,
  useGetPrintedOrderStatesQuery,
  useGetQrCodesStatsQuery,
} = dashboardApi;

export default dashboardApi;
